var slideshow_progress_time = 5;
var slideshows = [{
  url: "https://assets.kef.com/into-the-metaverse/stage-3-1/06%20Reabsorbed/",
  limit: 11, 
  image_filename: "reabsorbed-slide[NUM].jpg", 
  video_seq: "2,3",
  video_filenames: "https://www.youtube.com/watch?v=GP0ObpiStU4,https://www.youtube.com/watch?v=mzcKVGqUzSY",
}, {
  url: "https://assets.kef.com/into-the-metaverse/stage-3-1/01%20Latent%20Body/",
  limit: 10, 
  image_filename: "latent-body-slide[NUM].jpg", 
  video_seq: "2", 
  video_filenames: "https://www.youtube.com/watch?v=c6DtOkqfQD4",
}, {
  url: "https://assets.kef.com/into-the-metaverse/stage-3-1/03%20Duet%20Preview/", 
  limit: 12, 
  image_filename: "duet-slide[NUM].jpg", 
  video_seq: "2,3", 
  video_filenames: "https://www.youtube.com/watch?v=k4o0xk1BV5w,https://www.youtube.com/watch?v=Wt_WYn4sZRg",
}, {
  url: "https://assets.kef.com/into-the-metaverse/stage-3-1/04%20Absorb/", 
  limit: 11, 
  image_filename: "absorb-slide[NUM].jpg", 
  video_seq: "1", 
  video_filenames: "absorb-slide01.mp4",
}, {
  url: "https://assets.kef.com/into-the-metaverse/stage-3-1/05%20Intimate/", 
  limit: 10, 
  image_filename: "intimate-slide[NUM].jpg", 
  video_seq: "2", 
  video_filenames: "https://www.youtube.com/watch?v=RumgJjUDwcY",
}];
$(function() {
  // aria
  var aria_texts = general.decodeLocale(window.kef.assets.aria.texts);
  $('.metaverse-events-listing .btn').attr('aria-label', aria_texts.open);

  $('.metaverse-events-listing-upcoming .metaverse-event .btn-link').on('click', function() {
    var el = $(this).parents('.metaverse-event-text');
    el.toggleClass('active');
    if (el.hasClass('active')) {
      $('html,body').animate({
        scrollTop: el.offset().top - $('header').outerHeight(),
      }, 300);
    }
  });

  var s3_1 = $('#page-into-metaverse-s3-1');
  $('#metaverse-events-popup .metaverse-event', s3_1).each(function(i) {
    loadGallerySlideshow($(this), i);
  });
  // initGallerySlideshowCursor(s3_1);
  initVideo(s3_1);
  s3_1 = $('#page-into-metaverse-s3-1');
  initScrollHash(s3_1);
  $(window).on('load hashchange', function() {
    initScrollHash(s3_1);
  });
  $('#btn-wechat').on('click', function(e) {
    $('html,body').stop().animate({
      scrollTop: $('.metaverse-discord-content', s3_1).offset().top - $('#header').outerHeight(),
    }, 300);
    e.preventDefault();
  })

  var metaverse_event_gallery_slideshow;
  $('.metaverse-event .btn-popup, .metaverse-event[data-popup]').on('click', function(e) {
    var id = $(this).attr('data-popup'),
        popup = $(`#metaverse-events-popup .${id}`);
    
    if (popup.length == 1) {
      $(`#metaverse-events-popup`).addClass('active');
      $(`body`).addClass('metaverse-event-popup-active');
      popup.addClass('active');

      $(`.${id} .metaverse-event`).scrollTop(0);

      metaverse_event_gallery_slideshow = initGallerySlideshow(`.${id} .metaverse-event-gallery-slideshow`);
      initGallerySlideshowCursor($(`.${id}`, s3_1));
    }

    e.preventDefault();
  });

  $(document).on('video_worker_play', function(e) {
    s3_1.get(0).style.setProperty('--slideshow-progress-time', `${e.video.options.endTime}s`);
  });

  $(document).on('video_worker_pause', function(e) {
    s3_1.get(0).style.setProperty('--slideshow-progress-time', `${slideshow_progress_time}s`);
  });

  $(document).on('video_worker_ended', function(e) {
    metaverse_event_gallery_slideshow.slideNext();
    s3_1.get(0).style.setProperty('--slideshow-progress-time', `${slideshow_progress_time}s`);
  });
  
  $('#metaverse-events-popup .metaverse-event .btn-link').on('click', function(e) {
    $(`#metaverse-events-popup`).removeClass('active');
    $(`body`).removeClass('metaverse-event-popup-active');
    $(`#metaverse-events-popup .metaverse-event`).removeClass('active');
    video_player.stopAll();

    metaverse_event_gallery_slideshow.destroy(true, true);

    e.preventDefault();
  });
  
  // $('#metaverse-events-popup .metaverse-event .btn-link').on('click', function() {
  //   var el = $(this).parents('.metaverse-event-text');
  //   el.toggleClass('active');
  //   if (el.hasClass('active')) {
  //     // $('html,body').animate({
  //     //   scrollTop: el.offset().top - $('header').outerHeight(),
  //     // }, 300);
  //   }
  //   e.preventDefault();
  // });
});

function initScrollHash(el) {
  var hash = window.location.hash.replace('#', '');
  if (hash != '') {
    $('html,body').stop().animate({
      scrollTop: $('[name="'+hash+'"]', el).offset().top - $('#header').outerHeight(),
    }, 300);
  }
}

function initGallerySlideshowCursor(el) {
  var cursor = $('.metaverse-event-gallery-slideshow .swiper-cursor', el);
  $('.metaverse-event-gallery-slideshow', el).on('mouseover', function(e) {
    var _t = $(e.target);
    if (_t.hasClass('swiper-button')) {
      cursor.addClass('active');
      if (_t.hasClass('swiper-button-prev')) {
        cursor.addClass('swiper-cursor-prev').removeClass('swiper-cursor-next');
      } else if (_t.hasClass('swiper-button-next')) {
        cursor.addClass('swiper-cursor-next').removeClass('swiper-cursor-prev');
      } else {
        cursor.removeClass('swiper-cursor-prev').removeClass('swiper-cursor-next');
      }
    } else {
      cursor.removeClass('active');
    }
  }).on('mouseleave', function(e) {
    cursor.removeClass('active');
  }).on('mousemove touchmove', function(e) {
    var x = !isTouchDevice() ? e.pageX : e.touches[0].pageX;
    var y = !isTouchDevice() ? e.pageY : e.touches[0].pageY;
    var offset = $('.metaverse-event-gallery-slideshow', el).offset();
    x = x - offset.left;
    y = y - offset.top;
    cursor.css({
      // left: `${x}px`,
      // top: `${y}px`,
      // transform: `translate3d(calc(${x}px - 0%), calc(${y}px - 0%), 0)`,
      transform: `matrix(1, 0, 0, 1, ${x}, ${y}) translate3d(-50%, -50%, 0px)`,
    });
  });
}

function loadGallerySlideshow(el, config_i) {
  // const
  var config = slideshows[config_i],
      total = parseInt(config.limit),
      video_seq = config.video_seq.split(','),
      video_filenames = config.video_filenames.split(',');

  var gallery_slideshow_slides = $('.metaverse-event-gallery-slideshow .swiper .swiper-wrapper', el);
  for (var i = 1; i <= total; i++) {
    var fi = String(i).toString().padStart(2, '0'),
        filename = config.url + config.image_filename.replace('[NUM]', fi),
        slide_id = `slideshow_${config_i}_${fi}`,
        slide_html = `<div id="${slide_id}" class="swiper-slide">
          <img src="${filename}" alt="" loading="lazy">
        </div>`;

    var video_idx = video_seq.indexOf(String(i));
    if (video_idx >= 0) {
      filename = video_filenames[video_idx];
      if (filename.indexOf('https') < 0) {
        filename = 'mp4:' + config.url + video_filenames[video_idx];
      }

      slide_html = `<div class="swiper-slide">
        <div class="video-player-box">
          <script type="application/json" class="video-player-params">{"showControls":false,"loop":false}</script>
          <div class="video-player" data-id="${slide_id}" data-url="${filename}">
          </div>
          <div class="btn-play"><img src="https://assets.kef.com/into-the-metaverse/play-icon.png" alt="play" loading="lazy"></div>
        </div>
      </div>`;

      // slide_html = `<div class="swiper-slide">
      //  <video disablepictureinpicture controlslist="nofullscreen" autoplay poster muted playsinline webkit-playsinline preload="auto" loop>
      //    <source src="${filename}" type="video/mp4"></video>
      //  </video>
      // </div>`;
    }

    gallery_slideshow_slides.append(slide_html);
  };
}

function initGallerySlideshow(slider_class) {
  var gallery_slideshow_swiper = new Swiper(`${slider_class} .swiper`, {
    direction: 'horizontal',
    loop: true,
    // loopedSlides: 6,
    // initialSlide: $(`${slider_class} .swiper-slide-active`).index() || 0,
    autoplay: {
      delay: slideshow_progress_time * 1000,
    },
    pagination: {
      el: `${slider_class} .swiper-pagination`,
      // clickable: true,
      renderCustom: function(swiper, current, total) {
        var html = ``;
        // html += `<span class="swiper-pagination-label swiper-pagination-label-current">${current}</span>`;
        for (var i = 0; i < total; i++) {
          var idx = i+1;
          html += `<span class="swiper-pagination-bullet ${idx==current ? 'swiper-pagination-bullet-active' : ''}" tabindex="${i}">
            <span class="swiper-pagination-bullet-progressbar"></span>
          </span>`
        }
        // html += `<span class="swiper-pagination-label swiper-pagination-label-total">${total}</span>`;
        html += `<span class="swiper-pagination-label">${current} / ${total}</span>`;
        return html;
      },
      type: 'custom',
    },
    navigation: {
      nextEl: `${slider_class} .swiper-button-next`,
      prevEl: `${slider_class} .swiper-button-prev`,
    },
    scrollbar: {
      el: `${slider_class} .swiper-scrollbar`,
    },
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      767: {
      },
    },
    on: {
      slideChange: function() {
        video_player.stopAll();
      },
      slideChangeTransitionEnd: function(swiper) {
        video_player.stopAll();
        setTimeout(function() {
          var vid = $('.swiper-slide-active .video-player', $(swiper.el))
          if (vid.length == 1) {
            video_player.play(vid);
            swiper.autoplay.stop();
            $(swiper.el).addClass('swiper-video');
          } else {
            swiper.autoplay.start();
            $(swiper.el).removeClass('swiper-video');
          }
        }, 300);
      },
    },
  });
  
  return gallery_slideshow_swiper;
}

function initVideo(el) {
  video_player.init();
  $('.video-player-box .btn-play', el).on('click', function(e) {
    var vid = $(this);
    video_player.stopAll();
    video_player.play(vid);
    e.preventDefault();
  });
  $('.video-player-box', el).on('click', function(e) {
    var vid = $('.video-player', this);
    if (vid.parent('.video-player-box').hasClass('paused')) {
      video_player.play(vid);
    } else if (vid.parent('.video-player-box').hasClass('playing')) {
      video_player.pause(vid);
    }
    e.preventDefault();
  });
  // $('.video-player-box .btn-play').on('click', function(e) {
  //   var vid = $(this);
  //   video_player.play(vid);
  // });
  $(window).on('resize', function() {
    resizeIframe($('.video-player', el));
  });
}

function resizeIframe(_t) {
  return false;

  var iframe = $('iframe', _t);
  if (iframe.length == 0) return;
  iframe.removeAttr('style');

  // multi iframe
  // console.log(_t.width(), _t.height())
  if (window.innerWidth >= 1024) {
    // 16x9
    var h = _t.width() / 16 * 9 / _t.height();
    // console.log('16x9', h)
    if (h > 1) {
      iframe.css({
        height: `${h * 100}%`,
      });
    } else {
      var w = _t.height() / 9 * 16 / _t.width();
      // console.log('16x9', w)
      iframe.css({
        width: `${w * 100}%`,
      });
    }
  } else if (window.innerWidth >= 768) {
    // 1x1
    if (_t.width() > _t.height()) {
      // console.log('1x1', _t.width())
      iframe.css({
        height: _t.width(),
      });
    } else {
      // console.log('1x1', _t.height())
      var w = _t.height() / 5 / 4 / _t.width();
      iframe.css({
        width: _t.height(),
      });
    }
  } else {
    // 4x5
    var h = _t.width() / 4 * 5 / _t.height();
    // console.log('4x5', h)
    if (h > 1) {
      iframe.css({
        height: `${h * 100}%`,
      });
    } else {
      var w = _t.height() / 5 * 4 / _t.width();
      // console.log('4x5', w)
      iframe.css({
        width: `${w * 100}%`,
      });
    }
  }
}

function isTouchDevice() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}